/**
 * Texto de consentimiento VERSIONADO (HU-03). La versión consentida viaja en
 * el payload (`consentimientos.textoVersion`) y queda persistida: ante un
 * cambio del texto se publica una nueva versión, nunca se edita la vigente.
 */

export const VERSION_CONSENTIMIENTO = 'consent-v4';

export interface ClausulaConsentimiento {
  id: 'devolucionRecibida' | 'datosPersonales' | 'envioEmail';
  texto: string;
  detalle?: string;
  obligatoria: boolean;
  porDefecto: boolean;
}

export const TEXTO_CONSENTIMIENTO: {
  version: string;
  titulo: string;
  introduccion: string;
  clausulas: ClausulaConsentimiento[];
  piePagina: string;
} = {
  version: VERSION_CONSENTIMIENTO,
  titulo: 'Devolución y consentimiento',
  introduccion:
    'El profesional le informó el resultado del control médico realizado en el marco del art. 210 de la Ley de Contrato de Trabajo.',
  clausulas: [
    {
      id: 'devolucionRecibida',
      texto: 'Recibí la devolución de la visita médica',
      obligatoria: true,
      porDefecto: false,
    },
    {
      id: 'datosPersonales',
      texto: 'Acepto el tratamiento de mis datos personales (Ley 25.326)',
      detalle:
        'Sus datos de salud son datos sensibles y serán tratados únicamente para documentar este control.',
      obligatoria: true,
      porDefecto: false,
    },
    {
      id: 'envioEmail',
      texto: 'Quiero recibir mi copia por email',
      detalle: 'Si no la solicita ahora, su copia queda disponible a demanda (Ley 26.529).',
      obligatoria: false,
      porDefecto: true,
    },
  ],
  piePagina:
    'La firma en pantalla es una firma electrónica grafométrica que acredita la recepción de esta devolución (no constituye firma digital en los términos de la Ley 25.506).',
};
